var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002991",
    d: "M6.398 5.102a.78.78 0 0 1 .768-.657h4.873q.867 0 1.607.117a7 7 0 0 1 .982.234 4.4 4.4 0 0 1 .673.285c.244-1.556-.001-2.614-.843-3.573C13.532.453 11.858 0 9.717 0H3.5a.89.89 0 0 0-.879.75L.034 17.165c-.051.324.2.617.527.617h3.837l.964-6.113z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#60CDFF",
    d: "M15.303 5.081q-.029.178-.064.364c-.82 4.208-3.624 5.664-7.206 5.664H6.209a.886.886 0 0 0-.875.75L4.4 17.78l-.265 1.68a.467.467 0 0 0 .46.54H7.83a.78.78 0 0 0 .769-.657l.031-.165.61-3.863.04-.214a.78.78 0 0 1 .768-.657h.484c3.133 0 5.587-1.273 6.304-4.954.299-1.539.144-2.823-.647-3.726a3.1 3.1 0 0 0-.886-.683"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#008CFF",
    d: "M14.443 4.739a6 6 0 0 0-.797-.177q-.74-.119-1.608-.118H7.166a.776.776 0 0 0-.768.657l-1.036 6.567-.03.191a.886.886 0 0 1 .875-.75h1.824c3.582 0 6.387-1.455 7.207-5.664a10 10 0 0 0 .063-.364 4.4 4.4 0 0 0-.858-.342"
  })));
};
var Memo = /*#__PURE__*/memo(SvgPaypal);
export default Memo;